module.exports = __webpack_public_path__ + "img/yizhan.762bc0fb.png";